
import { VListItemTitle } from "vuetify/lib";

// Functional component
export default VListItemTitle;
